import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n        margin-top: 90px;\n        & > div {\n            margin-bottom: 104px;\n        }\n\n        & > div > div {\n            padding: 24px;\n        }\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    ", "\n\n    ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        text-align: center;\n        top: 88px;\n        right: unset;\n        left: 0;\n        width: 90%;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    ", "\n\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        & h2, h3 {\n            font-weight: 400;\n        }\n\n        & h2 {\n            text-transform: capitalize;\n        }\n\n        & h3 {\n            text-transform: initial;\n        }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        ", "\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    margin-bottom: 20px;\n    position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { Icon, Text } from '../../Atoms';
import { TYPES } from './index.constants';
export var StyledHeaderContainer = styled.div(_templateObject());
export var StyledContainerLight = function StyledContainerLight(props) {
  return "\n    background: ".concat(props.theme.components.contentDropdown.lightBackground, ";\n    color: ").concat(props.theme.components.contentDropdown.lightColor, ";\n\n    & > ").concat(StyledHeaderContainer, " {\n        color: ").concat(props.theme.components.contentDropdown.lightColor, ";\n    }\n\n    ").concat(Text.Styles.StyledText, ", h1, h2, h3 {\n        color: ").concat(props.theme.components.contentDropdown.lightColor, ";\n    }\n");
};
export var StyledContainerDark = function StyledContainerDark(props) {
  return "\n    background: ".concat(props.theme.components.contentDropdown.darkBackground, ";\n    color: ").concat(props.theme.components.contentDropdown.darkColor, ";\n\n    & > ").concat(StyledHeaderContainer, " {\n        color: ").concat(props.theme.components.contentDropdown.darkColor, ";\n    }\n\n    ").concat(Text.Styles.StyledText, ", h1, h2, h3 {\n        color: ").concat(props.theme.components.contentDropdown.darkColor, ";\n    }\n");
};
export var StyledContainer = styled.div(_templateObject2(), function (props) {
  return "\n        position: relative;\n        padding: ".concat(props.theme.components.contentDropdown.padding, ";\n        width: ").concat(props.width, ";\n        min-height: 80px;\n        max-height: 320px;\n        max-width: 100%;\n        border-radius: 6px;\n        box-shadow: ").concat(props.shadow ? '3px 0px 30px 0px rgba(0,0,0,0.25)' : '', ";\n        box-sizing: border-box;\n        transition: ").concat(props.theme.components.contentDropdown.transition, ";\n        transition-property: max-height;\n        transition-duration: ").concat(props.theme.components.contentDropdown.transitionDuration, ";\n        will-change: max-height;\n        transition-timing-function: linear;\n\n        ").concat(props.light ? StyledContainerLight(props) : StyledContainerDark(props), "\n\n        ").concat(!props.collapsed ? "\n                    max-height: ".concat(props.maxHeightCollapsed || props.theme.components.contentDropdown.maxHeight, ";\n                ") : '', "\n\n        ").concat(props.type === TYPES.COMPACT ? "\n            ".concat(props.collapsed ? 'height: 175px;' : "\n                overflow-y: hidden;\n                max-height: ".concat(props.maxHeightCollapsed, ";\n                "), "\n        ") : '', "\n    ");
}, media.max.phone(_templateObject3(), function (props) {
  return props.collapsed ? 'height: 175px;' : 'overflow-y: hidden;';
}));
export var StyledHeader = styled.div(_templateObject4(), function (props) {
  return "\n        width: 95%;\n        float: left;\n\n        ".concat(props.type === TYPES.COMPACT ? "\n            & h2, h3 {\n                font-weight: 400;\n            }\n\n            & h2 {\n                text-transform: capitalize;\n            }\n\n            & h3 {\n                text-transform: initial;\n            }\n            " : '', "\n    ");
}, media.max.phone(_templateObject5()));
export var StyledArrowContainer = styled.div(_templateObject6(), function (props) {
  return "\n        cursor: pointer;\n        font-family: ".concat(props.theme.components.contentDropdown.arrowFontFamily, ";\n        font-size: ").concat(props.theme.components.contentDropdown.arrowFontSize, ";\n        font-weight: ").concat(props.theme.components.contentDropdown.arrowFontWeight, ";\n        position: absolute;\n        right: 5px;\n        z-index: 10;\n\n        ").concat(props.disabled ? "\n                cursor: not-allowed;\n            " : '', "\n\n        ").concat(props.arrowWidth && props.hasBorder ? "width: ".concat(props.arrowWidth, ";") : '', "\n\n        ").concat(props.hasBorder ? "\n                border: ".concat(props.theme.components.contentDropdown.arrowBorder, ";\n                border-radius: ").concat(props.theme.components.contentDropdown.arrowBorderRadius, ";\n                padding: ").concat(props.theme.components.contentDropdown.arrowContainerPadding, ";\n\n                ").concat(props.disabled ? "\n                        border-color: ".concat(props.theme.components.contentDropdown.arrowBorderDisabled, ";\n                    ") : '', "\n            ") : '', "\n\n        ").concat(props.type === TYPES.COMPACT ? "\n            text-align: center;\n            top: 88px;\n            right: unset;\n            left: 0;\n            width: 95%;\n            " : '', "\n    ");
}, media.max.phone(_templateObject7()));
export var StyledArrowMsg = styled.span(_templateObject8());
export var StyledIcon = styled(Icon)(_templateObject9(), function (props) {
  return "\n        color: ".concat(props.theme.components.contentDropdown.iconColor, ";\n    ");
});
export var StyledIconContainer = styled.span(_templateObject10(), function (props) {
  return "\n        & > i > svg {\n            transition: ".concat(props.theme.components.contentDropdown.transition, ";\n            transition-property: transform;\n            transition-duration: 300ms;\n            will-change: transform;\n            transition-timing-function: linear;\n\n            ").concat(!props.collapsed ? "\n                        transform: rotate(90deg);\n                    " : '', "\n        }\n    ");
});
var StyledContent = styled.div(_templateObject11(), function (props) {
  return "\n        transition: ".concat(props.theme.components.contentDropdown.transition, ";\n        transition-property: max-height, opacity;\n        transition-duration: ").concat(props.theme.components.contentDropdown.transitionDuration, ";\n        will-change: max-height, opacity;\n        transition-timing-function: linear;\n        max-height: 0;\n        opacity: 0;\n        overflow-y: auto;\n\n        ").concat(!props.collapsed ? "\n                    opacity: 1;\n                    max-height: calc(".concat(props.theme.components.contentDropdown.maxHeight, " - 80px);\n                ") : '', "\n\n        ").concat(props.type === TYPES.COMPACT ? "\n            margin-top: 90px;\n            & > div {\n                margin-bottom: 104px;\n            }\n\n            & > div > div {\n                padding: 24px;\n            }\n            " : '', "\n    ");
}, media.max.phone(_templateObject12()));
StyledContent.displayName = 'StyledContent';
export { StyledContent };